import { AfterContentChecked, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { LoaderService } from './shared/services/loader.service'
import { LicenseManager } from 'ag-grid-enterprise'
import { environment } from 'src/environments/environment'
import { filter, Subject, takeUntil } from 'rxjs'
import { CookieService } from '@collab/comp-library'
import { MSAL_GUARD_CONFIG, MsalBroadcastService, MsalGuardConfiguration, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, InteractionType, PopupRequest, RedirectRequest } from '@azure/msal-browser';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterContentChecked , OnDestroy {
    public showExpandedNav!: boolean
    public navbarItems = [
        'Tickets',
        'Insights Hub',
        'PredictIQ',
        'Ticket Analytics',
        'Feedback Analytics',
        'Health Monitoring',
        'Accelerators',
        'Log Analysis',
        'Connectors',
        'Observability',
        'Dashboard',
        'Reliability Engineering',
    ]
    public breadcrumbs: any = null
    public environment = environment;
    public isIframe = false;
    private readonly _destroying$ = new Subject<void>();
    public isAzureLoading = false;
    public loginDisplay = false;
    isDashboardActive = false;

    constructor(
        @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
        public router: Router, private cdr: ChangeDetectorRef, public loaderService: LoaderService,
        private authService: MsalService,
        private msalBroadcastService: MsalBroadcastService,
        public cookie: CookieService,

    ) { }

    public ngOnInit(): void {
        this.showExpandedNav = true
        LicenseManager.setLicenseKey(
            'Using_this_{AG_Grid}_Enterprise_key_{AG-076964}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Ascendion,_Inc_(india)}_is_granted_a_{Multiple_Applications}_Developer_License_for_{4}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{13_April_2026}____[v3]_[01]_MTc3NjAzNDgwMDAwMA==8b1f76d745f60d93c4f960ad0b900c1c'
        );

        
        this.azureAd();

    }

    azureAd(): void {
        this.authService.handleRedirectObservable().subscribe();
        this.isIframe = window !== window.parent && !window.opener;

        this.msalBroadcastService.inProgress$.pipe(
            filter((status: InteractionStatus) => status === InteractionStatus.None),
            takeUntil(this._destroying$)
        ).subscribe(() => {
            this.setLoginDisplay();
        });
    }

    setLoginDisplay(): void {
        this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
        if (this.loginDisplay) {
            this.isAzureLoading = true;
            this.setCookie();
        } else {
            this.loginRedirect();
            this.setCookie();
        }
    }

    setCookie(): void {
        const accountName = this.authService.instance.getAllAccounts();
        accountName.forEach(account => {
            if (account.name) {
                this.cookie.setCookie('user_name', account.name, 1);
            }
        });
    }

    loginRedirect(): void {
        if (this.msalGuardConfig.interactionType === InteractionType.Popup) {
            const authRequest = this.msalGuardConfig.authRequest;
            const loginFn = authRequest ? this.authService.loginPopup({ ...authRequest } as PopupRequest) : this.authService.loginPopup();

            loginFn.subscribe((response: AuthenticationResult) => {
                this.authService.instance.setActiveAccount(response.account);
            });
        } else {
            const authRequest = this.msalGuardConfig.authRequest;
            authRequest ? this.authService.loginRedirect({ ...authRequest } as RedirectRequest) : this.authService.loginRedirect();
        }
    }

    public ngAfterViewInit() {
        this.loaderService.breadCrumbs$.subscribe((res) => {
            this.breadcrumbs = res
        })
    }

    public ngAfterContentChecked(): void {
        this.cdr.detectChanges()
    }

    ngOnDestroy(): void {
        this._destroying$.next(undefined);
        this._destroying$.complete();
    }
}
